import { createFileRoute } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { listActiveOffers } from "@/lib/academy.functions";

export const Route = createFileRoute("/aluno/ofertas")({
  ssr: false,
  component: OfertasPage,
});

function OfertasPage() {
  const { data, isLoading } = useQuery({
    queryKey: ["academy", "offers"],
    queryFn: () => listActiveOffers(),
    staleTime: 60_000,
  });
  const articleWaUrl = `https://wa.me/555596852045?text=${encodeURIComponent("Quero um artigo para minha empresa")}`;
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold tracking-tight">Ofertas exclusivas</h1>
        <p className="mt-1 text-sm text-muted-foreground">Condições especiais para alunos da Academia SVG.</p>
      </div>

      <div className="relative overflow-hidden rounded-2xl border border-primary/40 bg-gradient-to-br from-primary/20 via-primary/5 to-transparent p-6">
        <div className="absolute right-4 top-4 rounded-full bg-primary px-3 py-1 text-[10px] font-bold uppercase tracking-widest text-primary-foreground">
          Oferta especial
        </div>
        <div className="text-xs uppercase tracking-widest text-primary">Artigo otimizado para SEO</div>
        <h3 className="mt-2 text-2xl font-bold">Artigo SEO da sua empresa por R$ 79,90</h3>
        <p className="mt-2 max-w-2xl text-sm text-muted-foreground">
          Nossa equipe produz um artigo otimizado para SEO da sua empresa, publicado em portais parceiros para gerar autoridade e melhorar seu posicionamento no Google.
        </p>
        <div className="mt-4 flex flex-wrap items-center gap-3">
          <div className="text-3xl font-bold">R$ 79,90</div>
          <a href={articleWaUrl} target="_blank" rel="noopener" className="btn-primary text-sm">
            Quero um artigo para minha empresa
          </a>
        </div>
      </div>

      {isLoading ? (
        <p className="text-sm text-muted-foreground">Carregando…</p>
      ) : !data || data.length === 0 ? (
        <div className="card-glass text-sm text-muted-foreground">Nenhuma oferta ativa no momento.</div>
      ) : (
        <div className="grid gap-4 md:grid-cols-2">
          {data.map((o: any) => (
            <div key={o.id} className="card-glass">
              <div className="text-xs uppercase text-muted-foreground">{o.audience}</div>
              <h3 className="mt-1 text-lg font-semibold">{o.title}</h3>
              <p className="mt-2 text-sm text-muted-foreground">{o.description}</p>
              {o.coupon && (
                <div className="mt-3 inline-block rounded-lg border border-primary/40 bg-primary/10 px-3 py-1 text-xs font-mono">
                  Cupom: <strong>{o.coupon}</strong>
                </div>
              )}
              <a href={o.url} target="_blank" rel="noopener" className="btn-primary mt-4 inline-flex text-sm">
                Aproveitar oferta
              </a>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}